import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "mb-2"
};
const _hoisted_2 = {
  class: "flex items-end justify-items-stretch flex-nowrap"
};
const _hoisted_3 = {
  class: "flex-center flex-col flex-1 m-0.5 first:ml-0 last:mr-0"
};
const _hoisted_4 = {
  class: "w-full"
};
const _hoisted_5 = {
  class: "text-2xl font-bold"
};
const _hoisted_6 = {
  class: "text-sm"
};
const _hoisted_7 = {
  class: "text-center font-bold text-sky-600 font-bold"
};
import { Match } from "@/modules/match/entity";
import { Brackets } from "typeorm";
import dayjs from "dayjs";
import { app } from "@/di";
import { EventEmitter } from "@/modules/base/events";
import { AfterDayEvaluationEvent } from "@/modules/season/events/AfterDayEvaluationEvent";
import CalendarMatch from "@/modules/season/components/CalendarMatch.vue";
import CalendarFinish from "@/modules/season/components/CalendarFinish.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarTimeline',
  props: {
    season: null,
    days: {
      default: 9
    }
  },
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const startDate = ref();
    const matches = ref();
    let matchMap = collect();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      startDate.value = props.season.currentDate.clone();
      matches.value = await Match.createQueryBuilder('match').innerJoinAndSelect('match.homeTeam', 'homeTeam').innerJoinAndSelect('match.awayTeam', 'awayTeam').innerJoinAndSelect('match.matchday', 'matchday').innerJoin('matchday.season', 'season').where('season.current = true').andWhere(new Brackets(query => {
        query.where('homeTeam.user = true').orWhere('awayTeam.user = true');
      })).andWhere('matchday.scheduledAt >= :dateFrom AND matchday.scheduledAt <= :dateTo', {
        dateFrom: props.season.currentDate.subtract(Math.floor(props.days / 2), 'day').format(),
        dateTo: props.season.currentDate.add(Math.floor(props.days / 2), 'day').format()
      }).getMany();
      matchMap = collect(matches.value).mapWithKeys(match => [match.matchday.scheduledAt, match]);
    })), __temp = await __temp, __restore(), __temp);
    onUnmounted(app.get(EventEmitter).onOff(AfterDayEvaluationEvent, refresh));
    const days = computed(() => {
      return times(props.days).map(i => {
        let date = dayjs.utc(currentDate.value).subtract(Math.floor(props.days / 2) - i, 'days');
        return {
          date,
          match: matchMap.get(date.format('YYYY-MM-DD'))
        };
      });
    });
    const currentDate = computed(() => {
      if (startDate.value.week() !== props.season.currentDate.week()) {
        return startDate.value.endOf('week').toDate();
      }
      return props.season.currentDate.toDate();
    });
    watch(() => currentDate.value.getMonth(), refresh);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(days), ({
        date,
        match
      }) => {
        return _openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [date.isSame(__props.season.endDate, 'day') ? (_openBlock(), _createBlock(CalendarFinish, {
          key: 0,
          class: "p-2 py-3 -mx-6 mb-4 bg-slate-100 text-slate-700"
        })) : match ? (_openBlock(), _createBlock(CalendarMatch, {
          key: 1,
          edge: "",
          location: "",
          match: match,
          class: "p-2 py-3 -mx-6 mb-4 bg-slate-100 text-slate-700"
        }, null, 8, ["match"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
          class: _normalizeClass(["flex-center flex-col rounded w-full p-1 py-2", {
            'bg-slate-50 text-slate-400': date.isBefore(_unref(currentDate), 'day'),
            'bg-sky-600 text-sky-50 pt-3': date.isSame(_unref(currentDate), 'day'),
            'bg-sky-50 text-sky-600': date.isAfter(_unref(currentDate), 'day')
          }])
        }, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$date(date, 'D')), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$date(date, 'ddd')), 1)], 2)]);
      }), 256))]), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$date(_unref(currentDate), 'MMMM')), 1)]);
    };
  }
});